module.exports = __webpack_public_path__ + "static/img/20004 (5).d8a035f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/20000/20004 (5).jpg
// module id = LeNj
// module chunks = 14